// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchHeader":"XR","sortWrapper":"YR","shortCount":"ZR","fullCount":"_R","countWrapper":"aS"};